export default class RapportsOrganisationProduitsController {
	static $inject = [
		'$scope',
		'$state',
		'$uibModal',
		'RapportsActivitesService',
		'PaginationService',
		'notification',
		'$translate',
		'moment',
		'ModalService',
		'MassiaAuthService'
	];

	constructor(
		$scope,
		$state,
		$uibModal,
		RapportsActivitesService,
		PaginationService,
		notification,
		$translate,
		moment,
		ModalService,
		MassiaAuthService
	) {
		Object.assign(this, {
			$scope,
			$state,
			$uibModal,
			RapportsActivitesService,
			PaginationService,
			notification,
			$translate,
			moment,
			ModalService,
			MassiaAuthService,
			loading: false,
			unregister: []
		});
	}

	async $onInit() {
		this.idRapport = this.$state.params.idRapport;
		this.rapportLabel = this.$state.params.rapportLabel;
		await this.loadSocietes();
		if (this.societes.length > 0) {
			this.idSociete = this.societes[0].id;
		}

		if (this.idSociete) {
			await this.loadRegroupementSites(this.idSociete);

			if (this.regroupementSites.length > 0) {
				this.idRegroupementSite = this.regroupementSites[0].id;
				if (this.idRegroupementSite && this.idRapport) {
					await this.loadSecteursByRapportAndGroupeSite(this.idRapport, this.idRegroupementSite);
				}
			}
		}
		this.unregister = [];
		this.unregister.push(
			this.$scope.$watch(
				() => this.idSociete,
				async (newValue, oldValue) => {
					if (newValue === oldValue) return;
					await this.loadRegroupementSites(newValue);
					if (this.regroupementSites.length > 0) {
						this.idRegroupementSite = this.regroupementSites[0].id;
						if (this.idRegroupementSite && this.idRapport) {
							await this.loadSecteursByRapportAndGroupeSite(this.idRapport, this.idRegroupementSite);
						}
					}
				},
				true
			)
		);
	}
	$onDestroy = () => {
		for (let i = 0; i < this.unregister.length; i++) {
			this.unregister[i]();
		}
	};

	async loadSocietes() {
		this.startLoading();
		try {
			this.societes = await this.RapportsActivitesService.getSocietesCom();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}
	async loadRegroupementSites(idSociete) {
		this.startLoading();
		try {
			this.regroupementSites = await this.RapportsActivitesService.getRegroupementSitesBySociete(idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadSecteursByRapportAndGroupeSite(idRapport, idGroupeSite) {
		this.startLoading();
		try {
			this.secteurs = await this.RapportsActivitesService.getSecteursByRapportAndGroupeSite(idRapport, idGroupeSite);
			this.secteurs.forEach((secteur) => {
				//on ajoute au debut de la liste de produits un produit fictif pour chaque secteur
				secteur.produits.unshift({
					id: 0,
					idGroupeSite: idGroupeSite,
					idProduit: 0,
					idSecteur: secteur.id,
					isEnabled: true,
					labelProducteur: '',
					labelProduit: '',
					labelSecteur: secteur.label,
					order: 0
				});
			});
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	dragoverCallback(index, secteur) {
		if (index === 0) return false;
		this.dragOverSecteur = secteur;
		return true;
	}

	handleDrop(targetItemIndex, selectedItem) {
		// Trouve le secteur d'origine basé sur l'ID du secteur de l'élément sélectionné
		const secteurOrigin = this.secteurs.find((secteur) => secteur.id === selectedItem.idSecteur);

		// Trouve l'index de l'élément sélectionné dans la liste des produits du secteur d'origine
		const itemOriginIndex = secteurOrigin.produits.findIndex((produit) => produit.id === selectedItem.id);

		// Met à jour les informations de secteur de l'élément sélectionné avec celles du secteur de destination
		selectedItem.idSecteur = this.dragOverSecteur.id;
		selectedItem.labelSecteur = this.dragOverSecteur.label;

		// Détermine l'action à effectuer (monter ou descendre) en fonction de l'index de l'élément cible
		const action = targetItemIndex > itemOriginIndex ? 'up' : 'down';

		// Vérifie si le produit change de secteur
		const secteurOriginIndex = this.secteurs.findIndex((secteur) => secteur.id === secteurOrigin.id);
		const secteurTargetIndex = this.secteurs.findIndex((secteur) => secteur.id === this.dragOverSecteur.id);
		const isSecteurChanged = secteurOriginIndex !== secteurTargetIndex;

		// Déplace l'élément sélectionné selon l'action déterminée et si le secteur a changé ou non
		if (action === 'up') {
			if (isSecteurChanged) {
				// Si le secteur a changé, retire l'élément du secteur d'origine et l'ajoute au nouveau secteur
				secteurOrigin.produits.splice(itemOriginIndex, 1);
				this.dragOverSecteur.produits.splice(targetItemIndex, 0, selectedItem);
			} else {
				// Si le secteur n'a pas changé, ajoute l'élément à la nouvelle position et retire l'ancienne position
				this.dragOverSecteur.produits.splice(targetItemIndex, 0, selectedItem);
				this.dragOverSecteur.produits.splice(itemOriginIndex, 1);
			}
		} else if (action === 'down') {
			if (isSecteurChanged) {
				// Si le secteur a changé, retire l'élément du secteur d'origine et l'ajoute au nouveau secteur
				secteurOrigin.produits.splice(itemOriginIndex, 1);
				this.dragOverSecteur.produits.splice(targetItemIndex, 0, selectedItem);
			} else {
				// Si le secteur n'a pas changé, ajoute l'élément à la nouvelle position et retire l'ancienne position, en ajustant l'index
				this.dragOverSecteur.produits.splice(targetItemIndex, 0, selectedItem);
				this.dragOverSecteur.produits.splice(itemOriginIndex + 1, 1);
			}
		}

		this.reOrderProduits();
	}

	reOrderProduits() {
		this.secteurs.forEach((secteur) => {
			secteur.produits.forEach((produit, index) => {
				produit.order = index;
			});
		});
	}

	handleSelectedSecteur(secteur) {
		secteur.selected = true;
		return secteur;
	}

	async sauvegarder() {
		this.startLoading();
		try {
			const dataToSend = this.secteurs.flatMap((secteur) => secteur.produits.filter((produit) => produit.order !== 0));
			if (dataToSend.length > 0) {
				await this.RapportsActivitesService.saveRapportsOrganistaionsProduits(this.idRapport, this.idRegroupementSite, dataToSend);
				this.notification.success('STOCKS_CONFIGURATION_PRODUITS_NIVEAUX.SUCCESS_UPDATE');
			}
		} catch (ex) {
			this.notification.error(ex.data);
			return false;
		} finally {
			this.stopLoading();
		}
	}

	fermer() {
		this.$state.go('rapports-activites.list');
	}
	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	openAddReinitialiseModal(idRapport, idGroupeSite) {
		const _this = this;

		const modalInstance = this.$uibModal.open({
			animation: true,
			size: 'md',
			backdrop: false,
			windowClass: 'modern-modal',
			template: `                
                <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                    <div class="mas-col-fit">
                        <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                            <span style="color: white" aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"><span translate="GESTION_RAPPORTS_ACTIVITES.WARNING_REINITIALISATION"></span></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <span translate="GESTION_RAPPORTS_ACTIVITES.CONFIRM_REINITIALISATION"></span>
                </div>
                <div class="modal-footer">
                    <div class="mas-col-fit">
                        <div class="mas-row mas-jc-fend">
                            <div class="mas-col-fit">
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.validate()">
                                    <span translate="GESTION_RAPPORTS_ACTIVITES.VALIDER"></span>
                                </button>
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                                    <span class="massia-icon-door_exit"></span>
                                    <span class="hidden-xs" translate="FERMER"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>`,
			controllerAs: '$ctrl',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					this.validate = () => {
						$uibModalInstance.close();
					};
					this.close = () => $uibModalInstance.dismiss('cancel');
				}
			]
		});
		modalInstance.result.then(function () {
			_this.getReinitialiseRapportGroupeSite(idRapport, idGroupeSite);
		});
	}

	async getReinitialiseRapportGroupeSite(idRapport, idGroupeSite) {
		this.startLoading();
		try {
			await this.RapportsActivitesService.reinitialiseRapportGroupeSite(idRapport, idGroupeSite);
			await this.loadSecteursByRapportAndGroupeSite(this.idRapport, this.idRegroupementSite);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	// debug() {
	//     console.log(this.secteurs);
	// }
}
